/**
 * Client-side quiz date logic – must match server getCurrentQuizDate (GMT+10).
 */
const QUIZ_TZ_OFFSET_MS = 10 * 60 * 60 * 1000;

function formatUtcDate(date: Date): string {
  const year = date.getUTCFullYear();
  const month = `${date.getUTCMonth() + 1}`.padStart(2, '0');
  const day = `${date.getUTCDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function getTargetTimezoneMs(referenceDate: Date = new Date()): number {
  return referenceDate.getTime() + QUIZ_TZ_OFFSET_MS;
}

export function getCurrentQuizDate(referenceDate: Date = new Date()): string {
  const targetDate = new Date(getTargetTimezoneMs(referenceDate));
  return formatUtcDate(targetDate);
}
